<template>
  <div
    :class="`tag-container tw-cursor-default tw-flex tw-items-center tw-w-fit tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-font-medium tw-rounded ${
      props.color
    } ${props.expand ? 'contract' : ''}`"
  >
    <span v-if="prefilled" class="tw-rounded">{{
      props.numberQuestion +
      " " +
      getComponentUiText("app-component-assessments-question-pre-filled-tag-1")
    }}</span
    >&nbsp;
    <span class="expand-text tw-font-normal">{{ props.text }}</span>
  </div>
</template>

<script lang="ts" setup>
import { IAssessmentPrefillTagColor } from "@/interfaces/assessments/IAssessmentDetails";
import { getComponentUiText } from "@/utils/utilities";
import { PropType, defineProps } from "vue";

const props = defineProps({
  color: {
    type: String as PropType<IAssessmentPrefillTagColor>,
    required: true,
  },
  numberQuestion: { type: String, default: "", required: true },
  text: { type: String, default: "", required: false },
  expand: { type: Boolean, default: false, required: true },
  prefilled: { type: Boolean, default: true },
});
</script>

<style scoped lang="scss">
.tag-container {
  border: 1px solid var(--ui-rule, #d9ede2);
  line-height: 130%;
  background-color: #d9ede2;
  color: #01893d;
  min-width: 82px;
  height: 25px;
  .expand-text {
    display: none;
  }

  &.contract,
  &:hover {
    background-color: #ffffff !important;

    .expand-text {
      display: block;
    }
  }

  &.green {
    color: #01893d;
    border: 1px solid var(--ui-rule, #d9ede2);
    background-color: #d9ede2;
  }

  &.red {
    color: #f7553c;
    border: 1px solid var(--ui-rule, #fee5e2);
    background-color: #fee5e2;
  }

  &.orange {
    color: #fe9a05;
    border: 1px solid var(--ui-rule, #fff0da);
    background-color: #fff0da;
  }
  &.blue {
    color: #48a0ff;
    border: 1px solid var(--ui-rule, #e4f1ff) !important;
    background-color: #e4f1ff !important;
  }
}
</style>
